module.exports = __webpack_public_path__ + "static/media/fruit.41b73696.jpg";